import Box from "@mui/material/Box";
import React, {useEffect, useState} from "react";
import CustomerUserEntity from "../../../../API/customer/CustomerUserEntity";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import {ListItemText} from "@mui/material";
import ButtonCreate from "../../../../components/UI/button/ButtonCreate";
import PersonalizationModal from "./PersonalizationModal";
import WorkerService from "../../../../API/orders/job/WorkerService";
import {replaceEmptyStringsOnNull} from "../../../../utils/ReplaceEmptyStringsOnNull";
import {CUSTOMER_PASSPORT_FIELD_DEFAULTS, personalization} from "../../../../data/Personalization";
import {
    isKuhniVersoMebelDomain,
    KUHNI_HIDDEN_CUSTOMER_PERSONALIZATION_FIELDS,
} from "../../../../utils/isKuhniVersoMebelDomain";

const Personalization = ({role, handleModalAlert}) => {
    const [data, setData] = useState({})
    const [modal, setModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const isCustomer = role === "customerUser" || role === "customer"
    const hideCustomerPosition = isCustomer && isKuhniVersoMebelDomain()

    useEffect(() => {
        const api = isCustomer ? CustomerUserEntity.getAll : WorkerService.getAllOwn
        api().then(function (response) {
            setData(isCustomer
                ? {...CUSTOMER_PASSPORT_FIELD_DEFAULTS, ...response.data}
                : response.data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [])

    const handleClose = () => {
        setModal(false)
    }
    const handleSubmit = (res, handleClose) => {
        const {id, ...data} = res
        setLoading(true)
        const api = isCustomer ? CustomerUserEntity.edit : WorkerService.editOwn
        api(replaceEmptyStringsOnNull(data)).then(function (response) {
            setData(isCustomer
                ? {...CUSTOMER_PASSPORT_FIELD_DEFAULTS, ...response.data}
                : response.data)
            handleClose()
            handleModalAlert("Данные изменены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }
    return <Box sx={{
        display: "flex",
        flexDirection: "column",
        width: "700px",
        padding: "24px",
        borderRadius: "16px",
        border: (theme) => `${theme.palette.primary.stroke} 1px solid`
    }}>
        <Box sx={{
            display: "flex"
        }}>
            <List sx={{width: '100%', maxWidth: 350,}}>
                <ListItem>
                    <ListItemText primary={"Фамилия:"} secondary={data.lastName || "-"}/>
                </ListItem>
                <ListItem>
                    <ListItemText primary={"Имя:"} secondary={data.firstName || "-"}/>
                </ListItem>
                <ListItem>
                    <ListItemText primary={"Отчество:"} secondary={data.middleName || "-"}/>
                </ListItem>
            </List>
            <List sx={{width: '100%', maxWidth: 350}}>
                <ListItem>
                    <ListItemText primary={"Дата рождения:"} secondary={data.birthday || "-"}/>
                </ListItem>
                <ListItem>
                    <ListItemText primary={"Номер телефона:"} secondary={data.phoneNumber || "-"}/>
                </ListItem>
                {!hideCustomerPosition && <ListItem>
                    <ListItemText primary={"Дожность:"} secondary={data.position || "-"}/>
                </ListItem>}
            </List>
        </Box>
        {isCustomer && <Box sx={{display: "flex"}}>
            <List sx={{width: '100%', maxWidth: 350}}>
                <ListItem>
                    <ListItemText
                        primary={`${personalization.passport}:`}
                        secondary={data.passport || "-"}/>
                </ListItem>
            </List>
            <List sx={{width: '100%', maxWidth: 350}}>
                <ListItem>
                    <ListItemText
                        primary={`${personalization.dateOfIssuePassport}:`}
                        secondary={data.dateOfIssuePassport || "-"}/>
                </ListItem>
                <ListItem>
                    <ListItemText
                        primary={`${personalization.whoIssuedPassport}:`}
                        secondary={data.whoIssuedPassport || "-"}/>
                </ListItem>
            </List>
        </Box>}
        <Box sx={{
            display: "flex",
            justifyContent: "end"
        }}>
            <ButtonCreate icon={false} text={"Изменить"} width={90} onClick={() => setModal(true)}></ButtonCreate>
        </Box>
        <PersonalizationModal
            open={modal}
            organization={!isCustomer}
            onClose={handleClose}
            handleSubmit={handleSubmit}
            initValue={data}
            handleModalAlert={handleModalAlert}
            hiddenFields={hideCustomerPosition ? KUHNI_HIDDEN_CUSTOMER_PERSONALIZATION_FIELDS : []}
            loading={loading}
        />
    </Box>
}
export default Personalization